import * as React from 'react';

import { IPromoInfoSchema } from '../../types/promo';

import * as styles from './PromoItemIcon.css';
import { BankIcon } from './components/BankIcon';
import { PROMO_ICON } from './constants';

interface IPromoItemIconProps {
  promo: IPromoInfoSchema;
}

export function PromoItemIcon({ promo }: IPromoItemIconProps) {
  const { promoType, bank } = promo;

  let icon: React.ReactNode;

  if (promoType === 'bank') {
    icon = <BankIcon bank={bank} />;
  } else {
    const iconSrc = PROMO_ICON.get(promoType);

    /* istanbul ignore else */
    if (iconSrc) {
      icon = <img src={iconSrc} alt={promo.name} />;
    }
  }

  return (
    <div className={styles['container']}>
      <div className={styles['icon']}>{icon}</div>
    </div>
  );
}
